import { Injectable, inject } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable, forkJoin, tap } from 'rxjs';
import { GetBadges, GetGeneralScore, GetMonthlyScore, GetRanking, SetLoadingState } from './gamification.actions';
import { GamificationState } from './gamification.state';
import { CategoryBadges } from '../services/models/badges.model';
import { IRanking } from '../services/models/ranking.model';
import { ScoreDetail } from '../services/models/score-detail.model';

@Injectable({
  providedIn: 'root',
})
export class GamificationFacade {
  private readonly store = inject(Store);

  @Select(GamificationState.getIsLoading) isLoading$!: Observable<boolean>;
  @Select(GamificationState.getBadges) badges$!: Observable<CategoryBadges>;
  @Select(GamificationState.getMonthlyRanking) monthlyRanking$!: Observable<IRanking>;
  @Select(GamificationState.getGeneralRanking) generalRanking$!: Observable<IRanking>;
  @Select(GamificationState.getMonthlyScore) monthlyScore$!: Observable<ScoreDetail>;
  @Select(GamificationState.getGeneralScore) generalScore$!: Observable<ScoreDetail>;

  get badges() {
    return this.store.selectSnapshot(GamificationState.getBadges);
  }
  get monthlyScore() {
    return this.store.selectSnapshot(GamificationState.getMonthlyScore);
  }
  get generalScore() {
    return this.store.selectSnapshot(GamificationState.getGeneralScore);
  }

  getGamificationData(isBadges: boolean) {
    const calls = [this.getRanking()];
    if (isBadges) {
      calls.push(this.getBadges());
    }

    this.store.dispatch(new SetLoadingState(true));

    return forkJoin(calls).pipe(
      tap(() => {
        this.store.dispatch(new SetLoadingState(false));
      })
    );
  }

  getMonthlyScore(): Observable<GetMonthlyScore> {
    return this.store.dispatch(new GetMonthlyScore());
  }

  getGeneralScore(): Observable<GetGeneralScore> {
    return this.store.dispatch(new GetGeneralScore());
  }

  private getRanking(): Observable<GetRanking> {
    return this.store.dispatch(new GetRanking());
  }

  private getBadges(): Observable<GetBadges> {
    return this.store.dispatch(new GetBadges());
  }
}
